module.exports = __webpack_public_path__ + "img/spins_320.9975a6e3.png";